<script setup lang="ts">
import { useRodoStore } from '@/domains/rodo/store/useRodoStore.ts'
import DirectSalesRodo from '@/domains/direct-sales/components/direct-sales-rodo/direct-sales-rodo.vue'
import Loader from '@/components/Loader/Loader.vue'

const FORM_COMPONENTS = {
  HAVE_PRODUCT: () => import('@/domains/rodo/components/Form/HaveProduct/HaveProduct.vue'),
  NOT_HAVE_PRODUCT: () => import('@/domains/rodo/components/Form/NotHaveProduct/NotHaveProduct.vue'),
}

const { isUsingProduct } = useRodoStore()
const loading = ref(true)
const component = ref(null)
const currentComponent = computed(() =>
  isUsingProduct.value ? FORM_COMPONENTS.HAVE_PRODUCT : FORM_COMPONENTS.NOT_HAVE_PRODUCT,
)

onMounted(async () => {
  const module = await currentComponent.value()
  component.value = module.default
  loading.value = false
})

</script>

<template>
  <div class="rodoForm">
    <Loader
      v-show="loading"
      class="rodoForm__loader"
    />
    <div v-show="!loading">
      <component :is="component" />

      <DirectSalesRodo />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rodoForm {
  &__loader {
    margin: auto;
  }
}
</style>
